import axios from 'utils/axios';
import i18n from 'i18next';
import defaultLanguage, { code } from 'i18n/defaultLanguage';

/**
 * 'language': "zh" # 语言类型，["zh-CN", "en", "jp", "kr", "zh-TW"]
 * @param language
 * @return {*}
 */

export const queryFormConfig = () => {
  const item = defaultLanguage.options.find(i => i.code === i18n.language) || { code }
  return axios({
    method: 'post',
    url: '/v1/get_form_msg',
    data: {
      language: item.submitCode || item.code
    }
  })
};
